<template>
    <div class="card">
        <div class="card-body p-4">
            <h4 v-if="heading" class="mb-3 pb-2 border-bottom">
                {{ heading }}
            </h4>
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContentContainer",
    props: {
        heading: {
            type: String,
            default: ""
        }
    }
}
</script>
